import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "./app/hooks";
import {
  selectCredentials,
  setAlreadyLoggedByParam,
} from "./features/credentials/credentialsSlice";
import { Chat, Login } from "./pages";
import { useSearchParams } from "react-router-dom";
import { AppLoading } from "./AppLoading";
import { AppTheme } from "./AppTheme";
import { useSocketService } from "./hooks/useSocketService";
import { useHttpEscalloChatService } from "./service/http.escallo-chat.service";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { retrieveStoredCredentials } from "./service/credentials-store.service";

const defaultConfig = { email: "E-mail" };

function App(props: any) {
  const credentials = useAppSelector(selectCredentials);
  const [loading, setLoading] = useState(true);
  const dispatch = useAppDispatch();
  const [config, setConfig] = useState(defaultConfig);
  const [logoutEnabled, setLogoutEnabled] = useState(true);
  const { getFieldsAuth } = useHttpEscalloChatService();
  const [searchParams] = useSearchParams();
  const empresaParam = searchParams.get("empresa");
  const empresa = empresaParam ? empresaParam : "Escallo - WebChat";
  const description = searchParams.get("descricao");
  const logo = searchParams.get("logo");
  const favicon = document.getElementById("escallo-favicon") as any;
  const descriptionHTML = document.getElementById("escallo-description") as any;
  const storedCredentials = retrieveStoredCredentials();

  useEffect(() => {
    if (logo) {
      if (favicon) {
        favicon.href = logo;
      }
    }
    if (description) {
      if (descriptionHTML) {
        descriptionHTML.content = description;
      }
    }

    if (storedCredentials) {
      dispatch(setAlreadyLoggedByParam(true));
    }

    async function getConfig() {
      try {
        setLoading(true);
        const response = await getFieldsAuth();
        setConfig(response.fields);
        if (response.userLogout) {
          setLogoutEnabled(response.userLogout === "false" ? false : true);
        } else {
          setLogoutEnabled(false);
        }
        setLoading(false);
      } catch (error: any) {
        console.error(error);
        setConfig(defaultConfig);
        setLoading(false);
      }
    }

    getConfig();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const socket = useSocketService();

  return (
    <HelmetProvider>
      <AppTheme>
        <Helmet>
          <title>{empresa}</title>
        </Helmet>
        <AppLoading loading={loading}>
          {credentials ? (
            <Chat socket={socket} logoutEnabled={logoutEnabled} />
          ) : (
            <Login socket={socket} config={config} />
          )}
        </AppLoading>
      </AppTheme>
   </HelmetProvider>
  );
}

export default App;
